var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChainLink = function SvgChainLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    stroke: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21872 6.28079C8.71865 5.78087 8.04049 5.50003 7.33339 5.50003C6.62628 5.50003 5.94813 5.78087 5.44805 6.28079L2.78139 8.94746C2.52669 9.19345 2.32354 9.4877 2.18378 9.81305C2.04403 10.1384 1.97046 10.4883 1.96739 10.8424C1.96431 11.1965 2.03178 11.5476 2.16586 11.8753C2.29994 12.2031 2.49795 12.5008 2.74833 12.7512C2.99871 13.0016 3.29645 13.1996 3.62418 13.3337C3.9519 13.4677 4.30305 13.5352 4.65712 13.5321C5.0112 13.529 5.36112 13.4555 5.68647 13.3157C6.01181 13.176 6.30606 12.9728 6.55205 12.7181L7.28672 11.9841M6.78139 8.71813C7.28146 9.21805 7.95962 9.49889 8.66672 9.49889C9.37382 9.49889 10.052 9.21805 10.5521 8.71813L13.2187 6.05146C13.7045 5.54852 13.9733 4.87491 13.9672 4.17572C13.9611 3.47653 13.6807 2.8077 13.1862 2.31328C12.6918 1.81885 12.023 1.5384 11.3238 1.53233C10.6246 1.52625 9.95099 1.79504 9.44805 2.28079L8.71472 3.01412",
    stroke: "#490B2D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChainLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chain-link.a5b69eb0.svg";
export { ForwardRef as ReactComponent };